export enum ProfileActions {
  SET_PROFILE = '[PROFILE] Set Profile',
  CLEAR_PROFILE = '[PROFILE] Clear Profile',
  LOAD_PROFILE_OPTIONS = '[PROFILE] Load Profile Options',
  SET_OPTIONS_PROFILE = '[PROFILE] Set Options Profile',
  LOAD_PROFILE = '[PROFILE] Load Profile',
}
